import type { Pluscodes } from '~/core/entities/api/ApiPluscodes';
import type { PropertyFilters } from '~/core/entities/property/filters';
import type { NuxtListPropertiesApiReturn } from '~~/server/api/properties/index.get';

import { nuxtPropertiesRepository } from '~~/adapters/repositories/nuxt';

export interface PropertiesListingMapState {
	fetchedData: NuxtListPropertiesApiReturn | null;
	filters: PropertyFilters;
	pluscodes: Pluscodes;
	mapConfig: {
		center: google.maps.LatLngLiteral | google.maps.LatLng;
		zoom: number;
		maxZoom: number;
		minZoom: number;
		bounds: google.maps.LatLngBounds[] | google.maps.GeocoderGeometry['bounds'];
	};
}

export interface UseMapListingParams {
	filters: PropertyFilters;
}

function initializeMapState(): PropertiesListingMapState {
	return {
		fetchedData: null,
		filters: {
			transactionType: 'sell',
			countPluscodes: [],
			propertyTypes: [],
			locationSlug: 'sao-paulo-sp-brasil'
		},
		pluscodes: {},
		mapConfig: {
			zoom: 14,
			maxZoom: 18,
			minZoom: 12,
			bounds: [],
			center: {
				lat: -23.585,
				lng: -46.685
			}
		}
	};
}

export function useMapListing(params: UseMapListingParams) {
	const mapState = useState<PropertiesListingMapState>(
		'properties-listing-map',
		() => initializeMapState()
	);

	const propertiesMapDataFetcher = useAsyncData(
		'properties-listing-map',
		async () => {
			try {
				const [result, error] = await nuxtPropertiesRepository.list({
					page: 1,
					perPage: 1,
					onlyPluscodes: true,
					...params.filters,
					...mapState.value.filters,
					countPluscodes:
						mapState.value.filters.countPluscodes?.splice(0, 240) || [],
					pluscodesGroup: []
				});

				if (error) {
					console.error(error);
					mapState.value.fetchedData = null;
					return null;
				}

				mapState.value.fetchedData = result;

				if (result.pluscodes) {
					mapState.value.pluscodes = result.pluscodes;
				}

				return result;
			} catch (error) {
				console.error(error);
				mapState.value.fetchedData = null;
				return null;
			}
		},
		{ immediate: false }
	);

	async function updateFilters(newFilters: PropertyFilters) {
		mapState.value.filters = newFilters;

		await propertiesMapDataFetcher.execute();
	}

	return { propertiesMapDataFetcher, updateFilters };
}
